import React, { useContext } from "react";
import { WeFitStepSliderBlock } from "../WeFitStepSliderBlock";
import { PageQuestion } from "../../types/hexpertTypes";
import { HexpertContext } from "../../contexts/HexPertProvider";
import { UnitTypes } from "../../helpers/unitsConversion";

export const HexpertPressureChoiceElementBlock = (props: PageQuestion) => {
  const { Options, Label, FieldId } = props;
  const { state, dispatch } = useContext(HexpertContext);
  const currentStepIndex = state?.formAnswers
    ? Options?.findIndex((item) => item.Value === state?.formAnswers[FieldId])
    : Options?.findIndex((item) => item.Checked) >= 0
      ? Options?.findIndex((item) => item.Checked)
      : 0;

  return (
    <WeFitStepSliderBlock
      steps={Options}
      Label={Label}
      currentStepIndex={currentStepIndex}
      action={(value) =>
        dispatch({
          type: "setAnswer",
          payload: { [FieldId]: value },
        })
      }
      unit={state.unitSystem}
      unitType={UnitTypes.PRESSURE}
      {...props}
    />
  );
};
